import { Img } from "../_local/components/index";
import Input from "../_local/components/Input/index";
import { Field, Form, Formik } from "formik";
import Dropdown from "../component/Dropdown";
import { useState } from "react";
import { CircleX } from "lucide-react";

const campaigns = [
    {
        title: "Welcome Note",
        attempts: "1 times",
        description: "We'll send welcome note with your school website and social links."
    },
    {
        title: "School App Download Campaign",
        attempts: "3 times",
        description: "Send reminders to boost school app downloads."
    },
    {
        title: "App Login OTP",
        attempts: "1 times",
        description: "Secure parent logins with trusted OTP verification."
    },
    {
        title: "Social Media Campaign",
        attempts: "2 times",
        description: "Invite parents & students to join social campaigns."
    },
    {
        title: "Fee Follow-Ups",
        attempts: "3 times",
        description: "Send fee reminders with hassle free payment links."
    },
    {
        title: "Testimonials Campaign",
        attempts: "2 times",
        description: "Showcase excellence with parent testimonials."
    },
    {
        title: "Parental Insights",
        attempts: "2 times",
        description: "Remind parents to share feedback on school and activities."
    },
    {
        title: "Referral Campaign",
        attempts: "2 times",
        description: "Encourage parents to refer new students to the school with rewards or incentives."
    }
];

const USAGE_LIST = [{ label: "First time use (First year)", value: "First time use (First year)" }, { label: "Continuing from last year (Second year onward cost will be -50%)", value: "Continuing from last year (Second year onward cost will be -50%)" }];

interface StateProps {
    NUMBER_OF_STUDENTS: number;
    USAGE_STAGE: string;
}

const DEFAULT_DATA = {
    NUMBER_OF_STUDENTS: 0,
    USAGE_STAGE: ""
};

const WhatsApp = () => {
    const [state, setState] = useState<StateProps>(DEFAULT_DATA);
    const handleStateChange = (value?) => {
        setState(state => !value ? DEFAULT_DATA : value);
    }
    return (
        <div className="flex flex-col items-center gap-4">
            <Img src="images/Onboarding/YouAllAreSet.svg" />
            <div className="space-y-2 text-center">
                <h2 className="text-[3.5vh] font-manropeEB">Now Let’s Activate Your WhatsApp Experience.</h2>
                <p className="text-[2vh] text-gray-500">Get started with two quick recharges to unlock full WhatsApp functionality—send campaigns, connect instantly with <br /> website visitors, and keep your communication flowing effortlessly.</p>
            </div>
            <p className="text-[2vh] text-[black] front-manropeEB">To make sure everything runs smoothly, we just need to top-up two essential services</p>
            <div className="grid grid-cols-12 gap-4 mx-2">
                <div className="col-span-6">
                    <div className="grid grid-cols-12 gap-2 rounded-2xl bg-[#F5F5F5] shadow p-4 border border-[#CCCCCC]">
                        <div className="col-span-4">
                            <div className="space-y-2">
                                <Img src="/images/Onboarding/WhatsAppCampaignRecharge.svg" className="h-[8vh]" />
                                <h2 className="text-[2.4vh] font-manropeEB">WhatsApp Campaign <br />Recharge</h2>
                                <p className="text-[1.8vh] text-gray-500">This powers your school’s <br />outbound messages to leads <br />and parents via WhatsApp.</p>
                            </div>
                        </div>
                        <div className="col-span-8 space-y-4 border border-[#F5F5F5] border-l-[#CCCCCC] border-dashed pl-2">
                            <h2 className="text-[2.5vh] font-manropeEB">WhatsApp Campaign Recharge Calculator</h2>
                            <Formik
                                initialValues={{}}
                                // validationSchema={validationSchema}
                                onSubmit={async (values) => {
                                    console.log("values ", values);
                                    handleStateChange(values as StateProps);
                                }}
                            >
                                {({ handleSubmit }) => (
                                    <Form onSubmit={handleSubmit} className="space-y-2 w-full">
                                        {!!state?.NUMBER_OF_STUDENTS ? <div className="relative flex flex-col justify-between items-center gap-6 bg-[#5E4DE0] rounded-xl h-full w-full font-manrope p-2">
                                            <button type="button" onClick={() => handleStateChange()}><CircleX className="absolute top-2 right-2 bg-[white] rounded-full border border-[white] text-[#5E4DE0]" /></button>
                                            <div className="text-center space-y-1">
                                                <p className="text-[white] text-[6vh] font-manropeEB">₹ 2,000</p>
                                                <p className="text-[white] text-[2.2vh]">For {state?.NUMBER_OF_STUDENTS} Students</p>
                                                <p className="text-[white] text-[2.2vh]">{state?.USAGE_STAGE}</p>
                                            </div>
                                            <div className="w-full">
                                                <button className="bg-[white] text-[black] rounded-xl p-[2vh] w-full">Purchase Now</button>
                                            </div>
                                        </div> : <>
                                            <div className="space-y-[0.5vh]">
                                                <p className="text-[1.7vh] font-manropeSB">Number Of Students <span className="text-[red]">*</span></p>
                                                <Input
                                                    //   disable={disableForm}
                                                    //   label="Mobile Number"
                                                    name={`NUMBER_OF_STUDENTS`}
                                                    type="number"
                                                    placeHolder="Enter number students"
                                                    required
                                                />
                                            </div>
                                            <Dropdown label="What is your usage stage"
                                                name="USAGE_STAGE"
                                                options={USAGE_LIST}
                                            />
                                            <div>
                                                <button className="mt-4 bg-[#5E4DE0] text-[white] rounded-xl p-[2vh] w-full">Calculate Price</button>
                                            </div>
                                        </>}
                                    </Form>)}
                            </Formik>
                        </div>
                    </div>
                </div>
                <div className="col-span-6">
                    <div className="grid grid-cols-12 gap-2 h-full rounded-2xl bg-[#F5F5F5] shadow p-4 border border-[#CCCCCC]">
                        <div className="col-span-4">
                            <div className="space-y-2">
                                <Img src="/images/Onboarding/ChatBotReacharge.svg" className="h-[8vh]" />
                                <h2 className="text-[2.4vh] font-manropeEB">AI Chatbot <br /> WhatsApp Recharge</h2>
                                <p className="text-[1.8vh] text-gray-500">This enables <span className="text-[black] font-manropeSB">our smart <br /> assistant to send marketing materials when someone visits <br /> your website</span> and shares their number.</p>
                            </div>
                        </div>
                        <div className="col-span-8 border border-[#F5F5F5] border-l-[#CCCCCC] border-dashed pl-2">
                            <div className="flex flex-col justify-between items-center gap-6 bg-[#5E4DE0] rounded-xl h-full w-full font-manrope p-2">
                                <div></div>
                                <div className="text-center space-y-2">
                                    <p className="text-[white] text-[6vh] font-manropeEB">₹ 2,000</p>
                                    <p className="text-[white] text-[2.2vh]">500 Messages</p>
                                </div>
                                <div className="w-full">
                                    <button className="bg-[white] text-[black] rounded-xl p-[2vh] w-full">Purchase Now</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-span-12 space-y-4">
                <h2 className="text-center text-[3.5vh] font-manropeEB">What you will get?</h2>
                <div className="grid grid-cols-4 gap-4">
                    {campaigns?.map((item, index) => <div key={"asdasdadasdadasd" + index} className="space-y-1 rounded-2xl bg-[#F5F5F5] shadow p-4 border border-[#CCCCCC]">
                        <p className="text-[2vh] font-manropeEB">{item?.title}</p>
                        <p className="text-[1.8vh] font-manrope">Attempts: <span className="text-[blue]">{item?.attempts}</span></p>
                        <p className="text-[1.8vh] font-manrope">{item?.description}</p>
                    </div>)}
                </div>
            </div>
        </div>
    );
}

export default WhatsApp;